import React, { useState } from "react";
import BottomMenu from "../../common/others/BottomMenu";
import tools from "../../../assets/common/menu.svg";
import logout from "../../../assets/common/logout.svg";
import video1 from "../../../assets/common/video1.svg";
import GenericModal from "../../common/modals/GenericModal";
import ToolsOptions from "../ToolsOptions";
import {
  FlexRowBetween,
  GenericDiv,
  MediumFont,
  PopupForm,
  RespFont,
  TextWithPic,
} from "../../common/Style";
import { useHistory } from "react-router-dom";
import ClientRoutes from "../../../navigation/Routes";
import LogoutSpecipic from "../../common/LogOut/LogoutSpecipic";
import Accordion from "react-bootstrap/Accordion";
import { useSelector } from "react-redux";

const dict = {
  "סמס ראשון": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        ענבר ביטון ואיתי שטרית שמחים להזמינכם לחתונתם!
      </FlexRowBetween>
      <FlexRowBetween>פרטי האירוע ואישור הגעתכם בקישור:</FlexRowBetween>
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
      <FlexRowBetween>
        במידה וחל שינוי ניתן להיכנס לקישור ולהזין מחדש את תשובתכם.
      </FlexRowBetween>
      <FlexRowBetween>
        במידה והקישור אינו נפתח יש להגיב להודעה זו את מספר המגיעים.
      </FlexRowBetween>
    </PopupForm>
  ),
  "סמס שני": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        טרם אישרתם הגעתכם לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <FlexRowBetween>תשובתכם תסייע לנו להערך בהתאם:</FlexRowBetween>
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ ראשון": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        ענבר ביטון ואיתי שטרית שמחים להזמינכם לחתונתם!
      </FlexRowBetween>
      <FlexRowBetween>פרטי האירוע ואישור הגעתכם בקישור:</FlexRowBetween>
      <br />
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>ניתן לרשום לנו כאן את מספר המגיעים (1/2/3...)</MediumFont>
      </FlexRowBetween>
      <FlexRowBetween>
        <MediumFont>או השיבו 0 במידה ולא תגיעו.</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>
          במידה ואתם עדיין לא יודעים עדיף שתגיבו 0 כדי שתפסיקו לקבל הודעות
          ושיחות, במידה ותגיעו תוכלו לשלוח תשובה חדשה 🙏
        </MediumFont>
      </FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ שני": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        טרם אישרתם הגעתכם לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <br />
      <FlexRowBetween>״סופיה״ באר שבע 01/06/2022</FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>- כתבו לנו את מספר המגיעים (1/2/3...)</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>- אם לא תוכלו להגיע, אנא כתבו "0"</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>
          - במידה ואינכם בטוחים לגבי הגעתכם, אנא כתבו "0" כדי למנוע קבלת הודעות
          נוספות. כמובן שתוכלו לעדכן אותנו בהמשך במידה ותוכלו להגיע 🙏
        </MediumFont>
      </FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ שלישי": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>לא רוצים לרדוף אחריך בטלפון 😅</FlexRowBetween>
      <br />
      <FlexRowBetween>
        נשמח לדעת אם את/ה מגיע/ה לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <br />
      <FlexRowBetween>בעלי השמחה חייבים להיערך בהתאם 🙏</FlexRowBetween>
    </PopupForm>
  ),
};

const Instruction = () => {
  const { user } = useSelector((state) => state.authReducer);

  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [what2show, setWhat2show] = useState(null);

  let widthS = window.innerWidth; // 1728
  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />

      <Accordion defaultActiveKey="0">
        <RespFont
          psize={"20px"}
          csize={"24px"}
          style={{
            textAlign: "center",
            margin: "20px auto",
            fontFamily: "hebM",
            textDecoration: "underline",
            textDecorationColor: "#7b96c4",
            textDecorationThickness: "2px",
          }}
        >
          סרטוני חובה
        </RespFont>
        <Accordion.Item
          eventKey="0"
          style={{ borderTop: "1.3px solid #dee2e6" }}
        >
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>עמידה בזמנים</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              הנכם מתבקשים להזמין את האורחים שלכם עד תחילת העבודה שלנו. (אתם את
              החברים, ההורים את החברים שלהם והמשפחה הרחוקה, האחים את החברים שלהם
              וכן הלאה...). ההמלצה היא להזמין את האורחים חודש לפני האירוע...
            </div>
            <div style={{ fontFamily: "hebM" }}>
              שלא יווצר מצב לא נעים שאורח יגיב להודעה/שיחה: "אפילו לא הזמינו
              אותי".
            </div>
            <div>
              מתי מתבצע כל צעד בתהליך אישורי ההגעה? לחצו על תפריט, לוז - שם
              מפורט כל צעד בשירות שלנו 🙏
            </div>
            <div>
              * נציין כי לפעמים תהיה חריגה של יום/יומיים בביצוע השיחות (הלוז
              ישתנה בהתאם לאילוצים)
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>עריכת פרטי האירוע</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              מעבר לפרטים יבשים על האירוע ישנם דברים נוספים שמומלץ לראות
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://youtu.be/NlUWLeL2d2Q"}
              style={{ textDecoration: "none" }}
            >
              <GenericDiv
                style={{
                  width: "min-content",
                  margin: "20px auto",
                  marginBottom: "10px",
                }}
              >
                <RespFont pSize={"18px"} cSize={"20px"}>
                  סרטון
                </RespFont>
                <img
                  src={video1}
                  alt="video1"
                  style={{ width: "30px", marginRight: "20px" }}
                />
              </GenericDiv>
            </a>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>הוספת אורחים למערכת</div>
          </Accordion.Header>
          <Accordion.Body>
            <div
              style={{ fontWeight: "700", fontSize: "18px" }}
              className="animate__animated animate__pulse  animate__repeat-3"
            >
              חשוב מאוד להבין שכאשר אתם מוסיפים אנשים למערכת אולי אתם מזהים אותם
              לפי כינוי אבל ברגע ההושבה שדיילת מחפשת אותם במערכת היא לעולם לא
              תמצא 🤣😂, אז במידה ואתם עושים הושבה יש לרשום את שם האורח כפי
              שהוא, כמובן שגם אם הוספתם מישהו עם כינוי תוכלו אחרי זה לעבור
              ולשנות - יש לשים לב לנושא הזה.
            </div>
            <div>
              ישנן מספר דרכים להוסיף אורחים למערכת, ניתן גם לשלב במספר דרכים.
            </div>
            <div>
              יש להוסיף את האורחים עד תחילת העבודה שלנו שמוצג בתפריט, לו״ז,
              כמובן שגם לאורך התהליך ניתן להוסיף אורחים באופן חופשי
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                fontFamily: "hebM",
              }}
            >
              ניתן להוסיף ישירות מאנשי הקשר (ניתן להתחבר ממספר מכשירים שונים)
            </div>
            <FlexRowBetween>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/zbPGFEDPYSY"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    אייפון
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/2rhn5z3eFYA"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    אנדרואיד
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
            </FlexRowBetween>
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                fontFamily: "hebM",
              }}
            >
              או להקליד ידנית (אחד אחד) ישירות למערכת, או לאקסל
            </div>
            <FlexRowBetween>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/4oVnHWCLNy8"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    אקסל
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/4h9PZpL8Gv8"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    הקלדה ידנית
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
            </FlexRowBetween>
          </Accordion.Body>
        </Accordion.Item>
        {user.eventType && (
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <div style={{ paddingLeft: "20px" }}>
                עריכת מזמין + קשר, חובת צפיה!
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div>חלק גדול מהמוזמנים לחתונה אינם ישירים של הכלה והחתן</div>
              <div>ברירת המחדל של תחילת ההודעה הינה עם שמות הזוג</div>
              <div>
                ניתן, רצוי, מרשים, מכבד ומעלה משמעותית את המענה לשנות את ההקדמה
                בכל הודעה
              </div>
              <div>צפו בסרטון ועשו משהו פשוט שיתרום המון 🙏</div>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/6kDA3PlQs0s"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    סרטון
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
            </Accordion.Body>
          </Accordion.Item>
        )}

        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>
              כפולים + ללא מספר + חינמיים
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div>מומלץ לצפות</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://youtu.be/C0Hz54kCXL8"}
              style={{ textDecoration: "none" }}
            >
              <GenericDiv
                style={{
                  width: "min-content",
                  margin: "20px auto",
                  marginBottom: "10px",
                }}
              >
                <RespFont pSize={"18px"} cSize={"20px"}>
                  סרטון
                </RespFont>
                <img
                  src={video1}
                  alt="video1"
                  style={{ width: "30px", marginRight: "20px" }}
                />
              </GenericDiv>
            </a>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>תיקונים לאחר שיחות</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              בכל פעם שמסתיים סבב שיחות יש לבצע את מה שמוסבר בסרטון הבא:
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://youtu.be/hVZ_Lu1kaRI"}
              style={{ textDecoration: "none" }}
            >
              <GenericDiv
                style={{
                  width: "min-content",
                  margin: "20px auto",
                  marginBottom: "10px",
                }}
              >
                <RespFont pSize={"18px"} cSize={"20px"}>
                  סרטון
                </RespFont>
                <img
                  src={video1}
                  alt="video1"
                  style={{ width: "30px", marginRight: "20px" }}
                />
              </GenericDiv>
            </a>
          </Accordion.Body>
        </Accordion.Item>

        <RespFont
          psize={"18px"}
          csize={"22px"}
          style={{
            textAlign: "center",
            margin: "20px auto",
            fontFamily: "hebM",
            textDecoration: "underline",
            textDecorationColor: "#7b96c4",
            textDecorationThickness: "2px",
          }}
        >
          הסברים נוספים
        </RespFont>

        <Accordion.Item
          eventKey="6"
          style={{ borderTop: "1.3px solid #dee2e6" }}
        >
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>״אורח לא קיבל הודעה״</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              ראשית, מומלץ לא להיות לחוצים, תהליך אישורי ההגעה זה באמת תהליך ולא
              משהו שקורה ברגע.
            </div>
            <div>שנית, ודאו שהמספר שמוזן במערכת אכן המספר הנכון של האורח</div>
            <div>
              שבנאדם אומר שלא קיבל הודעה, 99 אחוז שהוא קיבל פשוט אנשים לא רואים
              הודעות sms אז אל תדאגו את הווצאפ הוא יראה, ואם באמת הוא חיפש ולא
              קיבל הודעה אז:
            </div>
            <div>
              לעיתים רחוקות חברות הסלולר חוסמות הודעות או לא מציגות את הקישור
              כלינק - אינו לחיץ ממספר סיבות: טלפון לא מוכר/ טלפון כשר/ הגנות או
              כל סיבה אחרת. מה שאני אומר כאן זה לא להילחץ. ראשית כתוב בהודעה:
              ״במידה והקישור אינו נפתח יש להגיב הודעה זו״ האורח מגיב ואנו נזין
              ידנית את תשובתו. מעבר לכך יש את סבבי הווצאפ והשיחות כך שבסופו של
              דבר נגיע אליו, אז אפשר להיות רגועים
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
            >
              היינו מאוד שמחים שיענו לנו כבר בהודעות הרגילות כי העלות שלנו
              נמוכה, תאמינו לנו אין לנו סיבה להשמיט הודעות
            </div>
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>
              טובתכם היא טובתנו!!!
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="7">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>חשוב שתכירו</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              חשוב לנו לציין כי בכל שלב של אישורי הגעה בין אם זה הודעות או שיחות
              אורח אשר לא יודע לתת תשובה סופית ולא רוצה שנמשיך לבדוק איתו - נציע
              לו לסמן שאינו מגיע והוא יכול תמיד לעדכן בקישור במידה וכן יוכל,
              במידה והאורח מסכים אתם תראו את זה בהערה, במידה ולא אזי נמשיך לבדוק
              איתו או שהוא יבקש מאיתנו לא להתקשר אליו יותר והוא יעדכן לבד
            </div>
            <div>
              חשוב להבין שבתשובות אלה האורחים 99 אחוז שלא יגיעו, פשוט מחוסר
              נעימות עונים כך, אתם לא צריכים בכלל להמשיך לקוות לגביהם, פשוט לא
              לקחת אותם בחשבון, אם תהיה הפתעה ואורח או שניים יגיעו מתוך קבוצה זו
              - הכל טוב, הם לא משנים לכם את ההתחייבות אל מול האולם או את ההושבה.
              בבקשה בבקשה בבקשה אל תהיו תמימים, גם מתוך אלה שכן אישרו הגעה יש
              הברזה של 5-15 אחוז ולכן מתחייבים לאולם תמיד על פחות 10 אחוז בערך,
              אז אל תגרמו לעצמיכם להפסיד יותר מידי בהתחננות לתשובה לאלה
              ש״יעדכנו״
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="8">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>שעות פעילות</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              שליחת הודעות וביצוע השיחות בין השעות 9-20, משתנה באופן רנדומלי,
              יסומן בלו״ז לאחר שבוצע
            </div>
            <div style={{ marginTop: "10px" }}>
              מענה לתמיכה בשעות 10-17, עדיפות לווצאפ
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="9">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>לא למחוק אורחים!</div>
          </Accordion.Header>
          <Accordion.Body>
            <div>
              1. כולם מקבלים הודעות תזכורת ואולי מישהו שלא מגיע ישאיר בכל זאת
              מתנה באשראי.
            </div>
            <div>
              2. אולי ישנה את דעתו בעקבות הודעת התזכורת וכן יחליט להגיע.
            </div>
            <div>
              3. לאחר האירוע אתם תמלאו מתנות במערכת והיא תייצא לכם אקסל להמשך
              החיים וכן אתם רוצים שבאקסל זה יהיו גם אלה שהזמנתם ולא הגיעו כדי
              שתדעו אתם והמשפחות בעתיד איך להחזיר.
            </div>
          </Accordion.Body>
        </Accordion.Item>
        {user.isDigitalSeat && (
          <Accordion.Item eventKey="10">
            <Accordion.Header>
              <div style={{ paddingLeft: "20px" }}>הושבה</div>
            </Accordion.Header>
            <Accordion.Body>
              <MediumFont>
                לפני שבכלל ניגשים להושבה יש לפנות למנהל ההושבה לעצות ודגשים
              </MediumFont>
              <div>לראות מהתחלה ועד הסוף!</div>
              <div>
                במידה ואתם חדים תשימו על מהירות 1.5 אבל לא לדלג כי כל שאלה
                שעלולה לעלות לכם - התשובה נמצאת בסרטון
              </div>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/YaK-dzRvzdI"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    סרטון
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {user.separation && (
          <Accordion.Item eventKey="11">
            <Accordion.Header>
              <div style={{ paddingLeft: "20px" }}>
                פיצול של המינים לשם הושבה נפרדת
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <MediumFont>
                במידה ורשומה אישרה מ 2 המינים נרצה לפצל ל 2 רשומות שונות על מנת
                להושיב את הגבר בשולחן כלשהו ואת האישה בשולחן אחר
              </MediumFont>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://youtu.be/Snk5FDm6x90"}
                style={{ textDecoration: "none" }}
              >
                <GenericDiv
                  style={{
                    width: "min-content",
                    margin: "20px auto",
                    marginBottom: "10px",
                  }}
                >
                  <RespFont pSize={"18px"} cSize={"20px"}>
                    סרטון
                  </RespFont>
                  <img
                    src={video1}
                    alt="video1"
                    style={{ width: "30px", marginRight: "20px" }}
                  />
                </GenericDiv>
              </a>
            </Accordion.Body>
          </Accordion.Item>
        )}
        <Accordion.Item eventKey="12">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>עריכת קירבה מרובה</div>
          </Accordion.Header>
          <Accordion.Body>
            <MediumFont>
              בבת אחת ניתן לבחור קבוצה שלמה/מספר רשומות ולשנות את הקירבה/קטגוריה
            </MediumFont>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://youtu.be/G2lgIx2g4YI"}
              style={{ textDecoration: "none" }}
            >
              <GenericDiv
                style={{
                  width: "min-content",
                  margin: "20px auto",
                  marginBottom: "10px",
                }}
              >
                <RespFont pSize={"18px"} cSize={"20px"}>
                  סרטון
                </RespFont>
                <img
                  src={video1}
                  alt="video1"
                  style={{ width: "30px", marginRight: "20px" }}
                />
              </GenericDiv>
            </a>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="13">
          <Accordion.Header>
            <div style={{ paddingLeft: "20px" }}>נוסחי הודעות</div>
          </Accordion.Header>
          <Accordion.Body>
            <MediumFont>
              <ul>
                <li>לא ניתן לשינוי</li>
                <li>עברו אלפי אירועים</li>
                <li>מענה מצוין - משמעות אישורי ההגעה</li>
                <li>תסמכו עלינו ותנו לנו לעבוד 🙏</li>
              </ul>
            </MediumFont>
            <FlexRowBetween>
              <div
                style={{
                  padding: "7px 12px",
                  border: "2px solid #f2f2f2",
                  borderRadius: "2px",
                  width: "max-content",
                }}
                onClick={() => setWhat2show("סמס ראשון")}
              >
                סמס ראשון
              </div>
              <div
                style={{
                  padding: "7px 12px",
                  border: "2px solid #f2f2f2",
                  borderRadius: "2px",
                  width: "max-content",
                }}
                onClick={() => setWhat2show("סמס שני")}
              >
                סמס שני
              </div>
            </FlexRowBetween>
            <FlexRowBetween style={{ marginTop: "15px" }}>
              <div
                style={{
                  padding: "7px 12px",
                  border: "2px solid #f2f2f2",
                  borderRadius: "2px",
                  width: "max-content",
                }}
                onClick={() => setWhat2show("ווצאפ ראשון")}
              >
                ווצאפ ראשון
              </div>
              <div
                style={{
                  padding: "7px 12px",
                  border: "2px solid #f2f2f2",
                  borderRadius: "2px",
                  width: "max-content",
                }}
                onClick={() => setWhat2show("ווצאפ שני")}
              >
                ווצאפ שני
              </div>
              <div
                style={{
                  padding: "7px 12px",
                  border: "2px solid #f2f2f2",
                  borderRadius: "2px",
                  width: "max-content",
                }}
                onClick={() => setWhat2show("ווצאפ שלישי")}
              >
                ווצאפ שלישי
              </div>
            </FlexRowBetween>
            <div style={{ height: "15px" }} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <div style={{ height: widthS > 768 ? "20px" : "200px" }}></div>
      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.User.main)}
                >
                  מוזמנים
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.todos)}
                  key={3}
                >
                  לו״ז
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.editDetails)}
                  key={3}
                >
                  הזמנה
                </TextWithPic>,
              ]}
            />
          }
        />
      )}

      {what2show && <GenericModal init={setWhat2show} div={dict[what2show]} />}

      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}
    </div>
  );
};

export default Instruction;
